(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[358],{

/***/ 69661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Avatar_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/Person.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var Person = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Avatar/avatarClasses.js


function getAvatarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiAvatar', slot);
}
const avatarClasses = (0,generateUtilityClasses/* default */.Z)('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);
/* harmony default export */ var Avatar_avatarClasses = ((/* unused pure expression or super */ null && (avatarClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useSlot.js
var useSlot = __webpack_require__(80560);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Avatar/Avatar.js
'use client';



const _excluded = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return (0,composeClasses/* default */.Z)(slots, getAvatarUtilityClass, classes);
};
const AvatarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none',
  variants: [{
    props: {
      variant: 'rounded'
    },
    style: {
      borderRadius: (theme.vars || theme).shape.borderRadius
    }
  }, {
    props: {
      variant: 'square'
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: true
    },
    style: (0,esm_extends/* default */.Z)({
      color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
      backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : (0,esm_extends/* default */.Z)({
      backgroundColor: theme.palette.grey[400]
    }, theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[600]
    })))
  }]
}));
const AvatarImg = (0,styled/* default */.ZP)('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = (0,styled/* default */.ZP)(Person, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});
function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = react.useState(false);
  react.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }
    setLoaded(false);
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded('loaded');
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded('error');
    };
    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;
    if (srcSet) {
      image.srcset = srcSet;
    }
    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}
const Avatar = /*#__PURE__*/react.forwardRef(function Avatar(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiAvatar'
  });
  const {
      alt,
      children: childrenProp,
      className,
      component = 'div',
      slots = {},
      slotProps = {},
      imgProps,
      sizes,
      src,
      srcSet,
      variant = 'circular'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  let children = null;

  // Use a hook instead of onError on the img element to support server-side rendering.
  const loaded = useLoaded((0,esm_extends/* default */.Z)({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const [ImgSlot, imgSlotProps] = (0,useSlot/* default */.Z)('img', {
    className: classes.img,
    elementType: AvatarImg,
    externalForwardedProps: {
      slots,
      slotProps: {
        img: (0,esm_extends/* default */.Z)({}, imgProps, slotProps.img)
      }
    },
    additionalProps: {
      alt,
      src,
      srcSet,
      sizes
    },
    ownerState
  });
  if (hasImgNotFailing) {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(ImgSlot, (0,esm_extends/* default */.Z)({}, imgSlotProps));
    // We only render valid children, non valid children are rendered with a fallback
    // We consider that invalid children are all falsy values, except 0, which is valid.
  } else if (!!childrenProp || childrenProp === 0) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarFallback, {
      ownerState: ownerState,
      className: classes.fallback
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = (Avatar);

/***/ }),

/***/ 44287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


const usePreviousProps = value => {
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePreviousProps);

/***/ }),

/***/ 31293:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job/[vertical]/[state]/[city]/[jobId]",
      function () {
        return __webpack_require__(42646);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12963);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);


var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var schemaJson = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: []
    };
    var formatJSON = function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": "".concat(breadcrumb.url),
                name: "".concat(breadcrumb.content)
            }
        };
    };
    var createBreadcrumbSchema = function() {
        schemaJson.itemListElement = breadcrumbs.map(function(breadcrumb, index) {
            return formatJSON(breadcrumb, index);
        }) || [];
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: breadcrumbs.map(function(param, index) {
                    var content = param.content, url = param.url;
                    return index + 1 !== breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "body2",
                        children: content
                    }, content) || index + 1 === breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        role: "heading",
                        variant: "body2",
                        children: content
                    }, content);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                "data-testid": "breadcrumbListSchema",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 5823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GAMAds; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_htl_bid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80976);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42660);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);







var GAMAds = function(param) {
    var slotName = param.slotName, slotProps = param.slotProps;
    var ref = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var dimensions = function() {
        if (isSmallViewport) {
            return {
                width: 320,
                height: 50
            };
        }
        if (isMediumViewport) {
            return {
                width: 468,
                height: 50
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_DIRECTORY_RR_1 */ .YQ.SEO_DIRECTORY_RR_1) {
            return {
                width: 300,
                height: 250
            };
        }
        if (slotName === _constants__WEBPACK_IMPORTED_MODULE_2__/* .HTL_SLOTS.SEO_PROV_PROFILE_RR_1 */ .YQ.SEO_PROV_PROFILE_RR_1) {
            return {
                width: 300,
                height: 600
            };
        }
        return {
            width: 728,
            height: 90
        };
    }();
    var width = dimensions.width, height = dimensions.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        className: slotName,
        item: true,
        xs: 12,
        display: "flex",
        justifyContent: "center",
        pt: {
            xs: 1,
            sm: 5
        },
        pb: {
            xs: 4,
            sm: 8
        },
        sx: {
            "&.seo-prov-profile-inline-1, &.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4,
                    md: 16
                },
                pb: 4
            },
            "&.seo-prov-profile-inline-2": {
                pt: {
                    xs: 4
                },
                pb: 4
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            width: "".concat(width, "px"),
            height: "".concat(height, "px")
        }, slotProps), {
            overflow: "visible",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_htl_bid__WEBPACK_IMPORTED_MODULE_1__/* .HTLBIDSlot */ .qF, {
                slotName: slotName
            })
        }))
    });
};



/***/ }),

/***/ 35492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export splitValueIntoParts */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23795);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 






var SPACE_CHAR = " ";
var WHITE_SPACE_REGEXP = /\s*$/;
var DOUBLE_QUOTES = '"';
var splitValueIntoParts = function(value, charLimit) {
    if (!value) {
        return {
            teaser: value
        };
    }
    var remainingWords = [];
    var teaserWords = value.split(SPACE_CHAR);
    while(teaserWords.join(SPACE_CHAR).length > charLimit){
        remainingWords.unshift(teaserWords.pop());
    }
    return {
        teaser: teaserWords.join(SPACE_CHAR),
        remaining: remainingWords.join(SPACE_CHAR)
    };
};
var ReadMore = function(_param) {
    var value = _param.value, _charLimit = _param.charLimit, charLimit = _charLimit === void 0 ? 500 : _charLimit, _ellipses = _param.ellipses, ellipses = _ellipses === void 0 ? "..." : _ellipses, _showLessButton = _param.showLessButton, showLessButton = _showLessButton === void 0 ? true : _showLessButton, _showDoubleQuotes = _param.showDoubleQuotes, showDoubleQuotes = _showDoubleQuotes === void 0 ? false : _showDoubleQuotes, _onShowMoreClick = _param.onShowMoreClick, onShowMoreClick = _onShowMoreClick === void 0 ? function() {} : _onShowMoreClick, _onShowLessClick = _param.onShowLessClick, onShowLessClick = _onShowLessClick === void 0 ? function() {} : _onShowLessClick, _showMoreLabel = _param.showMoreLabel, showMoreLabel = _showMoreLabel === void 0 ? "more" : _showMoreLabel, _showLessLabel = _param.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "less" : _showLessLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "charLimit",
        "ellipses",
        "showLessButton",
        "showDoubleQuotes",
        "onShowMoreClick",
        "onShowLessClick",
        "showMoreLabel",
        "showLessLabel"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsExpanded(!isExpanded);
        if (isExpanded) {
            onShowLessClick();
        } else {
            onShowMoreClick();
        }
    }, [
        isExpanded,
        onShowMoreClick,
        onShowLessClick
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return splitValueIntoParts(value, charLimit);
    }, [
        value,
        charLimit
    ]), teaser = ref1.teaser, remaining = ref1.remaining;
    var canBeToggled = value.length > charLimit;
    var splitContent = !isExpanded ? "".concat(teaser.replace(WHITE_SPACE_REGEXP, "")) : "".concat(teaser, " ").concat(remaining);
    var content = canBeToggled ? splitContent : value;
    var toggleLabel = isExpanded ? "".concat(showLessLabel) : "".concat(showMoreLabel);
    var hideToggle = canBeToggled && (!isExpanded || showLessButton);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            showDoubleQuotes && "".concat(DOUBLE_QUOTES),
            content,
            showDoubleQuotes && !hideToggle && "".concat(DOUBLE_QUOTES),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: remaining ? sanitize_html__WEBPACK_IMPORTED_MODULE_6___default()(remaining) : ""
                }
            }),
            hideToggle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    isExpanded && showDoubleQuotes && "".concat(DOUBLE_QUOTES),
                    isExpanded && "".concat(SPACE_CHAR),
                    !isExpanded && "".concat(ellipses).concat(SPACE_CHAR),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        sx: {
                            font: "inherit",
                            verticalAlign: "inherit",
                            textDecoration: "underline"
                        },
                        component: "button",
                        onClick: handleToggle,
                        children: toggleLabel
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMore);


/***/ }),

/***/ 58291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* eslint-disable no-nested-ternary */ 



var SeoConversionBox = function(param) {
    var city = param.city, crossSell = param.crossSell, enrollmentURL = param.enrollmentURL, header = param.header, pageType = param.pageType, resultType = param.resultType, serviceId = param.serviceId, state = param.state;
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isCCProvider = typeof resultType !== "undefined" && _constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULT_TYPE */ .sM[resultType] === _constants__WEBPACK_IMPORTED_MODULE_1__/* .SEARCH_RESULT_TYPE.PROVIDER */ .sM.PROVIDER && serviceId === "CHILDCARE" && crossSell;
    var avgPayRates = crossSell === null || crossSell === void 0 ? void 0 : crossSell.avgPayRates;
    var handleCareButton = function(e) {
        var ref;
        var amplitudeData = {
            cta_location: "header",
            cta_text: (ref = e.target.textContent) === null || ref === void 0 ? void 0 : ref.toString(),
            cta_type: "button"
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    var renderHeading = function() {
        if (isCCProvider) {
            return "Find other affordable childcare options" + "".concat(pageType === "LOCAL" ? " near you in ".concat(city, ", ").concat(state) : " in your area");
        }
        return header;
    };
    var renderCtaBtns = function() {
        if (isCCProvider) {
            return avgPayRates === null || avgPayRates === void 0 ? void 0 : avgPayRates.map(function(param) {
                var title = param.title, url = param.url, avgPayRate = param.avgPayRate;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    minWidth: "200px",
                    mx: 1.5,
                    mt: 1.5,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "contained",
                        size: "large",
                        fullWidth: true,
                        color: "secondary",
                        "data-testid": "conversion-cta-link",
                        onClick: handleCareButton,
                        children: [
                            title,
                            " $",
                            parseFloat(avgPayRate.rate.amount).toFixed(2),
                            "/",
                            _constants__WEBPACK_IMPORTED_MODULE_1__/* .RATE_DURATION_ABBREVIATIONS */ .r7[avgPayRate.rateDuration]
                        ]
                    })
                }, title);
            });
        }
        return _constants__WEBPACK_IMPORTED_MODULE_1__/* .CONVERSION_CTA_LABELS.map */ .dA.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                minWidth: "144px",
                mt: 1.5,
                mx: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    component: "a",
                    href: "".concat(enrollmentURL, "&intent=").concat(item.intent),
                    variant: "contained",
                    color: "secondary",
                    size: "medium",
                    sx: {
                        fontSize: "16px"
                    },
                    fullWidth: true,
                    "data-testid": "conversion-cta-link",
                    onClick: handleCareButton,
                    rel: "nofollow",
                    children: item.label
                })
            }, item.intent);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        container: true,
        bgcolor: function(theme) {
            return theme.palette.care.grey[100];
        },
        py: {
            xs: 3,
            sm: 5
        },
        px: 0,
        ml: "auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    mb: 1,
                    textAlign: "center",
                    component: "h3",
                    variant: "h2",
                    children: renderHeading()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                display: "flex",
                justifyContent: "center",
                flexWrap: !isMobile ? "nowrap" : "wrap",
                flexBasis: "100%",
                children: renderCtaBtns()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoConversionBox);


/***/ }),

/***/ 8410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21194);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);




var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var SeoGlobalNavbar = function(param) {
    var enrollmentURL = param.enrollmentURL, _internalLinkingMenuContent = param.internalLinkingMenuContent, internalLinkingMenuContent = _internalLinkingMenuContent === void 0 ? undefined : _internalLinkingMenuContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        baseURL: NEXT_PUBLIC_APP_URL,
        findJobURL: "/app/vhp/vertical-triage?memberType=sitter",
        logAnalyticsEvent: _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .logOrEnqueueEvent */ .sw,
        joinNowURL: enrollmentURL,
        internalLinkingMenu: {
            internalLinkingMenu: true,
            internalLinkingMenuContent: internalLinkingMenuContent
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoGlobalNavbar);


/***/ }),

/***/ 32778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useLDClientFlags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63880);



var useLDClientFlags = function() {
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__/* .useFeatureFlags */ .g)();
    var activeFlags = {};
    return Object.entries(_constants__WEBPACK_IMPORTED_MODULE_0__/* .UI_FEATURE_FLAGS */ .WV).reduce(function(acc, flag) {
        var ref;
        var _flag = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(flag, 2), flagName = _flag[0], flagDetails = _flag[1];
        var currentFlag = featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagDetails.id];
        acc[flagName] = currentFlag;
        return acc;
    }, activeFlags);
};


/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61730);

function useResponsive() {
    var isSmallViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Devices
    var isMediumViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.between("sm", "lg");
    }); // Large Mobile and Tablets
    var isLargeViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("lg");
    }); // Small and Large Desktops
    return {
        isSmallViewport: isSmallViewport,
        isMediumViewport: isMediumViewport,
        isLargeViewport: isLargeViewport
    };
}



/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ AmplitudeEvent; },
/* harmony export */   "UP": function() { return /* binding */ setPagePropertiesFromData; },
/* harmony export */   "rG": function() { return /* binding */ trackAmplitudeEvent; },
/* harmony export */   "sw": function() { return /* binding */ logOrEnqueueEvent; },
/* harmony export */   "xF": function() { return /* binding */ setDeviceDataFromHeaders; }
/* harmony export */ });
/* unused harmony exports WebPlatform, AMPLITUDE_DATE_FORMAT, AMPLITUDE_TIME_FORMAT, AnalyticsHelper, enqueEvent */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _care_amplitude__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91649);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);








var WebPlatform;
(function(WebPlatform) {
    WebPlatform["MW"] = "Mobile Web";
    WebPlatform["DT"] = "Desktop Web";
})(WebPlatform || (WebPlatform = {}));
var AmplitudeEvent;
(function(AmplitudeEvent) {
    AmplitudeEvent["applySegmentationFilter"] = "Apply Segmentation Filter";
    AmplitudeEvent["clickOnSegmentationFilter"] = "Click on Segmentation Filter";
    AmplitudeEvent["ctaInteracted"] = "CTA Interacted";
    AmplitudeEvent["providerProfileViewed"] = "Provider Profile Viewed";
    AmplitudeEvent["monetateAssetClicked"] = "Monetate Asset Clicked";
    AmplitudeEvent["seoPageViewed"] = "SEO Page Viewed";
    AmplitudeEvent["viatorCardClick"] = "SEO - Viator card clicked";
    AmplitudeEvent["testExposure"] = "Test Exposure";
    AmplitudeEvent["jobViewed"] = "Job Viewed";
    AmplitudeEvent["seoFeatureInteracted"] = "SEO Feature Interacted";
    AmplitudeEvent["errorViewed"] = "Error Viewed";
})(AmplitudeEvent || (AmplitudeEvent = {}));
var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var AMPLITUDE_DATE_FORMAT = "MMDDYYYY";
var AMPLITUDE_TIME_FORMAT = "hh:mm A";
var initialized = false;
var AnalyticsHelper = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsHelper() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AnalyticsHelper);
        this.amplitudeEventsQueue = [];
        this.setHeaderData = function(data) {
            _this.headerData = data;
        };
        this.setPageProperties = function(properties) {
            _this.pageProperties = properties;
        };
        this.getHeaderData = function() {
            return _this.headerData;
        };
        this.setEventInQueue = function(event) {
            // @ts-ignore FIX: event is of never type
            _this.amplitudeEventsQueue.push(event);
        };
        this.getEventFromQueue = function() {
            return _this.amplitudeEventsQueue.shift();
        };
        this.getCommonData = function() {
            var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
            var ref = _this.headerData || {}, deviceOs = ref.device_os, isMobile = ref.is_mobile, mobileBrowser = ref.mobile_browser, mobileBrowserVersion = ref.mobile_browser_version;
            var ref1 = _this.pageProperties || {}, seoPageId = ref1.seo_page_id, screenName = ref1.screen_name, screenTemplate = ref1.screen_template, ServiceIdForMember = ref1.service_id_for_member, slots = ref1.slots;
            var czenVisitorId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_VISITOR_COOKIE_KEY */ .iN);
            var czenSessionId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_SESSION_COOKIE_KEY */ .Ih);
            var screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
            var viewportResolution = "".concat(window.innerWidth, " x ").concat(window.innerHeight);
            var visitorId = czenVisitorId || "VisitorIdNotFound";
            var CZENSessionId = czenSessionId || "SessionIdNotFound";
            var deviceModel = (deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ").length) > 1 ? deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ")[0] : deviceOs;
            var webPlatform = isMobile === "true" ? WebPlatform.MW : WebPlatform.DT;
            var commonData = {
                czen_session_id: CZENSessionId,
                device_model: deviceModel,
                environment: publicRuntimeConfig.SENTRY_ENV,
                language: navigator.language,
                os_name: mobileBrowser,
                os_version: mobileBrowserVersion,
                referer: document.referrer,
                rendered_by: "seo-mfe",
                screen_name: screenName,
                screen_resolution: screenResolution,
                screen_template: screenTemplate,
                seo_page_id: seoPageId,
                service_id_for_member: ServiceIdForMember,
                slots: slots,
                userAgent: navigator.userAgent,
                viewport_resolution: viewportResolution,
                visitor_id: visitorId,
                web_platform: webPlatform
            };
            return commonData;
        };
        this.logEvent = function(payload) {
            try {
                if (!initialized) {
                    var careAnalyticsConfig = {
                        analyticsEnabled: publicRuntimeConfig.ANALYTICS_ENABLED === "true",
                        key: publicRuntimeConfig.AMPLITUDE_API_KEY,
                        commonData: _this.getCommonData()
                    };
                    (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .init */ .S1)(careAnalyticsConfig);
                    initialized = true;
                    // session id is available with a small delay after amplitude initialization
                    setTimeout(function() {
                        var ref;
                        var amplitudeSessionId = (ref = (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .getInstance */ .s8)()) === null || ref === void 0 ? void 0 : ref.getSessionId();
                        if (amplitudeSessionId) {
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .configureScope */ .e)(function(scope) {
                                var user = scope.getUser();
                                scope.setUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, user), {
                                    amplitudeSessionId: amplitudeSessionId
                                }));
                            });
                        }
                    });
                }
                var logEventPayload = {
                    name: payload.name,
                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload.data)
                };
                (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .Kz)(logEventPayload);
            } catch (e) {
                (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb)(e);
            }
        };
    }
    AnalyticsHelper.init = function init() {
        if (this.analytics === undefined) {
            this.analytics = new AnalyticsHelper();
        }
        return this.analytics;
    };
    return AnalyticsHelper;
}();
var enqueEvent = function(event) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setEventInQueue(event);
    return event;
};
var dequeEvent = function() {
    var analyticsInstance = AnalyticsHelper.init();
    return analyticsInstance.getEventFromQueue();
};
var logOrEnqueueEvent = function(param) {
    var name = param.name, data = param.data;
    if (!name || !data) return null;
    var analyticsInstance = AnalyticsHelper.init();
    if (analyticsInstance.getHeaderData() === undefined) {
        return enqueEvent({
            name: name,
            data: data
        });
    }
    return analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.logEvent({
        data: data,
        name: name
    });
};
var trackAmplitudeEvent = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    logOrEnqueueEvent({
        name: name,
        data: data
    });
};
var setPagePropertiesFromData = function(properties) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setPageProperties(properties);
};
var setDeviceDataFromHeaders = function(data) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setHeaderData(data);
    var eventsPresentInQueue = analyticsInstance.amplitudeEventsQueue.length;
    if (eventsPresentInQueue > 0) {
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < eventsPresentInQueue; i++){
            var ref = dequeEvent(), eventName = ref.name, eventData = ref.data;
            trackAmplitudeEvent(eventName, eventData);
        }
        return eventsPresentInQueue;
    }
    return data;
};


/***/ }),

/***/ 42646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ job_JobDetailPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 12 modules
var CoreGlobalFooter = __webpack_require__(11566);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Divider/Divider.js
var Divider = __webpack_require__(81956);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/ProfileAvatar/ProfileAvatar.js + 3 modules
var ProfileAvatar = __webpack_require__(90346);
// EXTERNAL MODULE: ./src/utils/formatStartDate.ts
var formatStartDate = __webpack_require__(26008);
// EXTERNAL MODULE: ./src/utils/payRangeHelper.ts
var payRangeHelper = __webpack_require__(32150);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/Jobs/JobIntro.tsx









var JobIntro = function(param) {
    var title = param.title, hiResImageURL = param.hiResImageURL, city = param.city, state = param.state, joinNowURL = param.joinNowURL, payRange = param.payRange, startDate = param.startDate, type = param.type;
    var ref, ref1;
    var formattedStartDateAvatar = (0,formatStartDate/* formatStartDate */.O)(startDate);
    var formattedStartDateSubtitle = (0,formatStartDate/* formatStartDate */.O)(startDate, true);
    var payRangeString = (0,payRangeHelper/* default */.Z)((payRange === null || payRange === void 0 ? void 0 : (ref = payRange.hourlyRateTo) === null || ref === void 0 ? void 0 : ref.amount) || /* istanbul ignore next (default value) */ "", (payRange === null || payRange === void 0 ? void 0 : (ref1 = payRange.hourlyRateFrom) === null || ref1 === void 0 ? void 0 : ref1.amount) || /* istanbul ignore next (default value) */ "");
    var handleJoinToApply = function(e) {
        var amplitudeData = {
            cta_text: e.target.textContent,
            cta_type: "button"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "md",
        disableGutters: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            maxWidth: {
                md: "780px"
            },
            px: {
                md: 3
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    lg: 6,
                    sx: function(theme) {
                        return (0,_define_property/* default */.Z)({
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: theme.spacing(4)
                        }, theme.breakpoints.up("md"), {
                            marginTop: theme.spacing(0),
                            maxWidth: "315px",
                            justifyContent: "flex-start",
                            alignItems: "start"
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                        alt: title,
                        size: "squareMedium",
                        src: hiResImageURL !== null && hiResImageURL !== void 0 ? hiResImageURL : undefined,
                        sx: function(theme) {
                            var _obj;
                            return _obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
                                width: "120px",
                                height: "120px",
                                fontSize: "48px"
                            }), (0,_define_property/* default */.Z)(_obj, "width", "288px"), (0,_define_property/* default */.Z)(_obj, "height", "288px"), (0,_define_property/* default */.Z)(_obj, "fontSize", "72px"), (0,_define_property/* default */.Z)(_obj, "& .MuiAvatar-root", {
                                width: "100%",
                                height: "100%"
                            }), _obj;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            height: "100%",
                            justifyContent: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    component: "div",
                                    width: "100%",
                                    mb: {
                                        md: 2
                                    },
                                    sx: {
                                        fontSize: {
                                            md: "h1.fontSize"
                                        }
                                    },
                                    children: formattedStartDateAvatar.month.toLocaleUpperCase()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h1",
                                    component: "div",
                                    width: "100%",
                                    m: 0,
                                    sx: {
                                        fontSize: {
                                            md: "display1.fontSize"
                                        }
                                    },
                                    children: formattedStartDateAvatar.day.toUpperCase()
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    lg: 5,
                    maxWidth: {
                        md: "360px"
                    },
                    justifyContent: {
                        md: "flex-start"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: function(theme) {
                            return (0,_define_property/* default */.Z)({
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                margin: theme.spacing(1),
                                width: "100%"
                            }, theme.breakpoints.up("md"), {
                                margin: theme.spacing(0, "auto"),
                                width: "340px",
                                textAlign: "left",
                                alignItems: "flex-start"
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h1",
                                sx: function(theme) {
                                    var _obj;
                                    return _obj = {
                                        marginTop: theme.spacing(1)
                                    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                                        marginBottom: theme.spacing(0)
                                    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
                                        maxWidth: "90%",
                                        textAlign: "center"
                                    }), _obj;
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                mt: 1,
                                children: "".concat(city, ", ").concat(state)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                "justify-content": "center",
                                maxWidth: "200px",
                                children: [
                                    payRangeString && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 6,
                                        md: 5,
                                        sx: function(theme) {
                                            var ref;
                                            return (0,_define_property/* default */.Z)({
                                                borderRight: "6px solid ".concat((ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.grey[300]),
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginTop: theme.spacing(1)
                                            }, theme.breakpoints.up("md"), {
                                                alignItems: "flex-start"
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h2",
                                                children: payRangeString
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body3",
                                                color: "secondary",
                                                children: "Hourly rate"
                                            })
                                        ]
                                    }),
                                    type && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 6,
                                        md: 7,
                                        sx: function(theme) {
                                            return (0,_define_property/* default */.Z)({
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginTop: theme.spacing(1),
                                                borderRight: "0"
                                            }, theme.breakpoints.up("md"), {
                                                alignItems: "center"
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    children: constants/* JOB_TYPES */.d9[type]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body3",
                                                    color: "secondary",
                                                    children: "Job type"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        mt: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: {
                                            xs: "center",
                                            md: "flex-start"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "Starts ".concat(formattedStartDateSubtitle.month, " ").concat(formattedStartDateSubtitle.day)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: joinNowURL,
                                rel: "nofollow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    onClick: handleJoinToApply,
                                    variant: "contained",
                                    sx: function(theme) {
                                        return (0,_define_property/* default */.Z)({
                                            marginTop: theme.spacing(3)
                                        }, theme.breakpoints.up("md"), {
                                            marginTop: theme.spacing(2),
                                            marginBottom: theme.spacing(1)
                                        });
                                    },
                                    children: "Join to apply"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Jobs_JobIntro = (JobIntro);

// EXTERNAL MODULE: ./src/components/ReadMore.tsx
var ReadMore = __webpack_require__(35492);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
;// CONCATENATED MODULE: ./src/components/Jobs/JobDescription.tsx




var JobDescription = function(param) {
    var profileDesc = param.profileDesc;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            pt: 2,
            pb: 3,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    mb: 2,
                    children: "About the job"
                }),
                isSmallViewport ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore/* default */.Z, {
                    gutterBottom: true,
                    component: "div",
                    variant: "body2",
                    charLimit: 155,
                    value: profileDesc,
                    showMoreLabel: "more"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    children: profileDesc
                })
            ]
        })
    });
};
/* harmony default export */ var Jobs_JobDescription = (JobDescription);

;// CONCATENATED MODULE: ./src/components/Jobs/HousekeepingJobPreferences.tsx


var HousekeepingJobPreferences = function(param) {
    var jobPreferences = param.jobPreferences;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            jobPreferences.homeSize && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        "Home Size: ",
                        jobPreferences.homeSize.numberOfBedrooms,
                        "\xa0",
                        jobPreferences.homeSize.numberOfBedrooms === 1 ? "bedroom" : "bedrooms",
                        ",\xa0",
                        jobPreferences.homeSize.numberOfBathrooms,
                        "\xa0",
                        jobPreferences.homeSize.numberOfBathrooms === 1 ? "bathroom" : "bathrooms"
                    ]
                })
            }),
            jobPreferences.frequency && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        "Frequency: ",
                        jobPreferences.frequency
                    ]
                })
            }),
            jobPreferences.servicesNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    children: [
                        "Services Needed: ",
                        jobPreferences.servicesNeeded.join(", ")
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Jobs_HousekeepingJobPreferences = (HousekeepingJobPreferences);

;// CONCATENATED MODULE: ./src/components/Jobs/TutoringJobPreferences.tsx


var TutoringJobPreferences = function(param) {
    var jobPreferences = param.jobPreferences;
    return jobPreferences.subjectAreas && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body2",
            children: [
                "Subject Areas: ",
                jobPreferences.subjectAreas.join(", ")
            ]
        })
    });
};
/* harmony default export */ var Jobs_TutoringJobPreferences = (TutoringJobPreferences);

;// CONCATENATED MODULE: ./src/components/Jobs/JobAdditionalDetails.tsx





var JobAdditionalDetails = function(param) {
    var jobPreferences = param.jobPreferences, serviceName = param.serviceName;
    var headline = function() {
        return serviceName === constants/* SERVICE_ID_FOR_JOB_DETAILS.housekeeping */.Dg.housekeeping || serviceName === constants/* SERVICE_ID_FOR_JOB_DETAILS.tutoring */.Dg.tutoring ? "Job details" : "Who you'll care for";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            pt: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                mb: 2,
                children: "Additional details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        children: headline()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sx: {
                            mt: 1
                        },
                        children: [
                            jobPreferences.__typename === "HousekeepingJobPreferences" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_HousekeepingJobPreferences, {
                                jobPreferences: jobPreferences
                            }),
                            jobPreferences.__typename === "TutoringJobPreferences" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_TutoringJobPreferences, {
                                jobPreferences: jobPreferences
                            }),
                            (jobPreferences.__typename === "ChildCareJobPreferences" || jobPreferences.__typename === "PetCareJobPreferences") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                children: jobPreferences.additionalDetails.join(", ")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Jobs_JobAdditionalDetails = (JobAdditionalDetails);

;// CONCATENATED MODULE: ./src/components/Jobs/JobPreferences.tsx



var JobPreferences = function(param) {
    var jobPreferences = param.jobPreferences, serviceName = param.serviceName;
    var headline = function() {
        switch(serviceName){
            case constants/* SERVICE_ID_FOR_JOB_DETAILS.housekeeping */.Dg.housekeeping:
                return "Housekeeper preferences";
            case constants/* SERVICE_ID_FOR_JOB_DETAILS.tutoring */.Dg.tutoring:
                return "Tutor preferences";
            default:
                return "Caregiver preferences";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            pt: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                mb: 2,
                children: headline()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                children: jobPreferences.map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            display: "list-item",
                            my: 1,
                            mx: 2.5,
                            children: value
                        })
                    }, value);
                })
            })
        ]
    });
};
/* harmony default export */ var Jobs_JobPreferences = (JobPreferences);

;// CONCATENATED MODULE: ./src/components/Jobs/JobSchedule.tsx


var JobSchedule = function(param) {
    var scheduleDayArrayMapped = param.scheduleDayArrayMapped, scheduleTimeArray = param.scheduleTimeArray;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            pt: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h2",
                mb: 2,
                children: "Job schedule"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                children: scheduleDayArrayMapped.map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 4,
                                md: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    fontSize: "1rem",
                                    m: 1,
                                    ml: 0,
                                    fontWeight: "bold",
                                    children: value
                                })
                            }, value),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    fontSize: "1rem",
                                    m: 1,
                                    children: scheduleTimeArray[index]
                                })
                            }, scheduleTimeArray[index])
                        ]
                    }, value);
                })
            })
        ]
    });
};
/* harmony default export */ var Jobs_JobSchedule = (JobSchedule);

;// CONCATENATED MODULE: ./src/components/Jobs/OtherJobItem.tsx



var OtherJobItem = function(param) {
    var title = param.title, href = param.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 1,
        mb: 2,
        sx: function(theme) {
            var ref;
            return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("sm"), {
                display: "inline-block",
                padding: theme.spacing(0, 2),
                borderLeft: "2px solid ".concat((ref = theme.palette.care) === null || ref === void 0 ? void 0 : ref.grey[300]),
                "&:first-child": {
                    borderLeft: "none",
                    paddingLeft: 0
                }
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: href,
            underline: "none",
            sx: {
                fontWeight: "bold",
                fontSize: function(theme) {
                    return theme.typography.body2.fontSize;
                }
            },
            children: title
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Jobs/NearbyJobs.tsx






var NearbyJobs = function(param) {
    var jobs = param.jobs;
    var nearbyJobTrack = function() {
        var amplitudeData = {
            cta_location: "bottom",
            cta_text: "view similar jobs"
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        maxWidth: "md",
        sx: {
            mt: 4
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 1,
                    sm: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h2",
                    children: "Similar jobs nearby"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                children: jobs.map(function(job) {
                    var _seekerAvatar;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        md: 5,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            mt: 1,
                            sx: {
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: job.url || "",
                                onClick: nearbyJobTrack,
                                underline: "none",
                                sx: function(theme) {
                                    return {
                                        color: theme.palette.text.primary,
                                        "&:hover": {
                                            color: theme.palette.text.primary
                                        }
                                    };
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    mt: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* default */.Z, {
                                                alt: "profile",
                                                src: (_seekerAvatar = job.seekerAvatar) !== null && _seekerAvatar !== void 0 ? _seekerAvatar : undefined,
                                                size: "xLarge",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    height: "100%",
                                                    justifyContent: "center",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h5",
                                                            component: "div",
                                                            width: "100%",
                                                            children: (0,formatStartDate/* formatStartDate */.O)(job.job.startDate).month.toLocaleUpperCase()
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h2",
                                                            component: "div",
                                                            width: "100%",
                                                            children: (0,formatStartDate/* formatStartDate */.O)(job.job.startDate).day.toUpperCase()
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            ml: 2,
                                            maxWidth: "240px",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h4",
                                                    children: job.job.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "info1",
                                                        color: "secondary",
                                                        children: job.city
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }, job.job.title);
                })
            }, "nearbyJobs"),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            children: "Or take a look at some other job options:"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        maxWidth: "75%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherJobItem, {
                                        href: "/babysitting-jobs",
                                        title: "Babysitting Jobs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherJobItem, {
                                        href: "/nanny-jobs",
                                        title: "Nanny Jobs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherJobItem, {
                                        href: "/tutoring-jobs",
                                        title: "Tutoring Jobs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherJobItem, {
                                        href: "/housekeeping-jobs",
                                        title: "Housekeeping Jobs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherJobItem, {
                                        href: "/pet-care-jobs",
                                        title: "Pet Care Jobs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherJobItem, {
                                        href: "/senior-care-jobs",
                                        title: "Senior Care Jobs"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "otherJobs")
        ]
    });
};
/* harmony default export */ var Jobs_NearbyJobs = (NearbyJobs);

// EXTERNAL MODULE: ./src/components/SeoConversionBox.tsx
var SeoConversionBox = __webpack_require__(58291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/lib/ApolloClient.ts + 75 modules
var ApolloClient = __webpack_require__(77414);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./src/API/getJobDetails.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getSegmentationJobDetails(\n    $seoSegmentId: ID!\n    $isSeniorCare: Boolean!\n    $isChildCare: Boolean!\n    $isPetCare: Boolean!\n    $isHousekeeping: Boolean!\n    $isTutoring: Boolean!\n  ) {\n    getSEOSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {\n      breadcrumbs {\n        content\n        url\n      }\n    }\n    getSEOSegmentationJobDetails(seoSegmentId: $seoSegmentId) {\n      seoSegmentationJob {\n        job {\n          title\n          id\n          startDate\n          serviceType\n          hourlyRateRange {\n            hourlyRateFrom {\n              amount\n              currencyCode\n            }\n            hourlyRateTo {\n              amount\n              currencyCode\n            }\n          }\n        }\n        city\n        state\n        seekerAvatar\n        description\n        type\n        schedule\n        serviceId\n        serviceIdForMember\n        jobPreferences {\n          ... on SeniorCareJobPreferences @include(if: $isSeniorCare) {\n            assistsMobility\n            caresForWounds\n            doesBathing\n            doesCompanionship\n            doesFeeding\n            doesHeavyLifting\n            doesLightHousekeeping\n            doesNotSmoke\n            helpsStayingActive\n            isComfortableWithPets\n            ownsTransportation\n            prepsMeals\n            promptsMedication\n            runsErrands\n            transports\n          }\n          ... on ChildCareJobPreferences @include(if: $isChildCare) {\n            additionalDetails\n            doesHomeworkHelp\n            doesLaundry\n            doesLightHousekeeping\n            doesNotSmoke\n            dropPickupChildren\n            isComfortableWithPets\n            ownsTransportation\n            prepsMeals\n            runsErrands\n          }\n          ... on PetCareJobPreferences @include(if: $isPetCare) {\n            additionalDetails\n            doeOvernightCare\n            doesBoarding\n            doesFeeding\n            doesGrooming\n            doesMedicineAdministration\n            doesNotSmoke\n            doesPlayAndExercise\n            doesTraining\n            doesWalking\n            doesWasteCleanup\n            ownsTransportation\n          }\n          ... on HousekeepingJobPreferences @include(if: $isHousekeeping) {\n            frequency\n            homeSize {\n              numberOfBathrooms\n              numberOfBedrooms\n            }\n            isComfortableWithPets\n            ownsTransportation\n            providesEquipment\n            providesSupplies\n            servicesNeeded\n          }\n          ... on TutoringJobPreferences @include(if: $isTutoring) {\n            doesNotSmoke\n            educationLevel\n            isComfortableWithPets\n            ownsTransportation\n            subjectAreas\n          }\n        }\n      }\n\n      nearbyJobs {\n        job {\n          title\n          startDate\n        }\n        city\n        seekerAvatar\n        url\n      }\n\n      pageMetadata {\n        indexable\n        canonicalURL\n        title\n        metaDescriptions\n        metaKeywords\n      }\n      googleRichCardStructuredJson\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_JOB_DETAILS = (0,lib/* default */.ZP)(_templateObject());
/* harmony default export */ var getJobDetails = (GET_JOB_DETAILS);

// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(49093);
// EXTERNAL MODULE: ./src/utils/GoogleAdsManager/getGAMVerticalShortName.ts
var getGAMVerticalShortName = __webpack_require__(28057);
// EXTERNAL MODULE: ./src/utils/getDeviceCharacteristics.ts
var getDeviceCharacteristics = __webpack_require__(93867);
// EXTERNAL MODULE: ./src/utils/reqHeaderToEntriesObj.ts
var reqHeaderToEntriesObj = __webpack_require__(28906);
;// CONCATENATED MODULE: ./src/components/pages/segmentationDetails/job/jobDetailPageProps.ts











var isLocal = "production" === "development";
var getJobDetailData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, req, res, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, startPageGSSP, apolloOptions, startApolloClient, apolloClient, stopApolloClient, seoSegmentId, isSeniorCare, isChildCare, isPetCare, isHousekeeping, isTutoring, userAgent, deviceCharHeader, deviceChar, startGetPageData, data, err, stopGetPageData, ldClientFlags, _careContext, ldClient, ldUser, ldTargetAttributes, clientFlagPromises, ref9, additionalGAMRules, stopPageGSSP;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, req = param.req, res = param.res;
                    startPageGSSP = performance.now();
                    apolloOptions = {
                        logError: req.log.error.bind(req.log),
                        logInfo: req.log.info.bind(req.log)
                    };
                    startApolloClient = performance.now();
                    apolloClient = (0,ApolloClient/* getApolloClient */.W)(apolloOptions);
                    stopApolloClient = performance.now();
                    seoSegmentId = "/job/".concat(query.vertical, "/").concat(query.state, "/").concat(query.city, "/").concat(query.jobId);
                    isSeniorCare = Boolean((ref = query.vertical) === null || ref === void 0 ? void 0 : ref.toString().includes("seniorcare"));
                    isChildCare = Boolean((ref1 = query.vertical) === null || ref1 === void 0 ? void 0 : ref1.toString().includes("childcare"));
                    isPetCare = Boolean((ref2 = query.vertical) === null || ref2 === void 0 ? void 0 : ref2.toString().includes("petcare"));
                    isHousekeeping = Boolean((ref3 = query.vertical) === null || ref3 === void 0 ? void 0 : ref3.toString().includes("housekeeping"));
                    isTutoring = Boolean((ref4 = query.vertical) === null || ref4 === void 0 ? void 0 : ref4.toString().includes("tutoring"));
                    userAgent = req.headers["user-agent"] || "";
                    deviceCharHeader = ((ref5 = req.headers["x-akamai-device-characteristics"]) === null || ref5 === void 0 ? void 0 : ref5.toString()) || "";
                    deviceChar = isLocal ? (0,getDeviceCharacteristics/* default */.Z)(userAgent, deviceCharHeader) : (0,reqHeaderToEntriesObj/* default */.Z)(deviceCharHeader, ";");
                    startGetPageData = performance.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        apolloClient.query({
                            query: getJobDetails,
                            variables: {
                                seoSegmentId: seoSegmentId,
                                isSeniorCare: isSeniorCare,
                                isChildCare: isChildCare,
                                isPetCare: isPetCare,
                                isHousekeeping: isHousekeeping,
                                isTutoring: isTutoring
                            }
                        })
                    ];
                case 2:
                    data = _state.sent();
                    if (!data.data) {
                        req.log.error({
                            event: "SeoJobDetailPageLoadError",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            query: query,
                            res: res,
                            deviceChar: deviceChar,
                            data: data
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    req.log.error({
                        event: "SeoJobDetailPageLoadError",
                        seoSegmentId: seoSegmentId,
                        userAgent: userAgent,
                        query: query,
                        res: res,
                        deviceChar: deviceChar,
                        err: err
                    });
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 4:
                    stopGetPageData = performance.now();
                    req.log.info({
                        event: "SeoJobDetailPageLoadSuccess",
                        seoSegmentId: seoSegmentId,
                        userAgent: userAgent,
                        deviceChar: deviceChar,
                        query: query,
                        res: res
                    });
                    ldClientFlags = {};
                    _careContext = req.careContext, ldClient = _careContext.ldClient, ldUser = _careContext.ldUser;
                    ldTargetAttributes = {
                        seoSegmentId: seoSegmentId,
                        deviceChar: deviceChar,
                        pageTemplate: common/* PageTemplate.JOB_PROFILE */.P.JOB_PROFILE
                    };
                    if (!(ldClient && ldUser)) return [
                        3,
                        6
                    ];
                    ldUser.custom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ldUser.custom), {
                        seoSegmentId: seoSegmentId,
                        pageTemplate: common/* PageTemplate.JOB_PROFILE */.P.JOB_PROFILE
                    });
                    clientFlagPromises = Object.values(constants/* UI_FEATURE_FLAGS */.WV).filter(function(flag) {
                        return flag.condition(ldTargetAttributes);
                    }).map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(flag) {
                            var _;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _ = flag.id;
                                        return [
                                            4,
                                            ldClient.variationDetail(flag.id, ldUser, undefined)
                                        ];
                                    case 1:
                                        ldClientFlags[_] = _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(flag) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        4,
                        Promise.all(clientFlagPromises)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    additionalGAMRules = {
                        contType: "provider",
                        vertical: (0,getGAMVerticalShortName/* getGAMVerticalShortName */.W)((ref9 = (ref6 = data.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.getSEOSegmentationJobDetails) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.seoSegmentationJob) === null || ref8 === void 0 ? void 0 : ref8.serviceId) !== null && ref9 !== void 0 ? ref9 : "")
                    };
                    stopPageGSSP = performance.now();
                    req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
                    req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
                    req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;
                    return [
                        2,
                        {
                            props: {
                                serviceShortName: query.vertical,
                                data: data.data,
                                testName: query.testIDToFireTestExposureEvent || null,
                                deviceChar: deviceChar,
                                ldClientFlags: ldClientFlags,
                                additionalGAMRules: additionalGAMRules
                            }
                        }
                    ];
            }
        });
    });
    return function getJobDetailData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var jobDetailPageProps = (getJobDetailData);

;// CONCATENATED MODULE: ./src/utils/mapJobPreferences.ts

// Array of keys to exclude from job preferences
var keysToExclude = [
    "frequency",
    "homeSize"
];
var mapJobPreferences = function(data) {
    if (data) {
        // Convert the keys of the object into an array of strings, only including ones that return true
        var attributesArray = Object.keys(data).filter(function(key) {
            return !keysToExclude.includes(key);
        }).filter(function(key) {
            return data[key] && !Array.isArray(data[key]);
        });
        // Convert key strings from camelCase to Sentence case
        attributesArray = attributesArray.map(function(key) {
            if (Object.prototype.hasOwnProperty.call(constants/* JOB_PREFERENCES */.wu, key)) {
                return constants/* JOB_PREFERENCES */.wu[key];
            }
            return key;
        });
        // Remove the __typename index
        attributesArray.shift();
        // Remove duplicate fields
        attributesArray = attributesArray.filter(function(element, i) {
            return i === attributesArray.indexOf(element);
        });
        return attributesArray;
    }
    return [];
};
/* harmony default export */ var utils_mapJobPreferences = (mapJobPreferences);

;// CONCATENATED MODULE: ./src/utils/mapJobSchedule.ts
// EXAMPLE INPUT: 'Mon 2pm-8pm\nTue 2pm-8pm\nWed 2pm-8pm\nThu 2pm-8pm\nFri 2pm-8pm'
var dayMap = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday"
};
var mapJobSchedule = function(data) {
    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
        // Convert the string to an array of days
        var scheduleArray = data.split("\n");
        // Separate the Days from Times in two arrays
        var scheduleDayArray = scheduleArray.map(function(str) {
            return str.split(" ")[0];
        });
        var scheduleTimeArray = scheduleArray.map(function(str) {
            return str.split(" ")[1];
        });
        // Reformat the days to be full strings
        var scheduleDayArrayMapped = scheduleDayArray.map(function(key) {
            return dayMap[key];
        });
        return {
            scheduleDayArrayMapped: scheduleDayArrayMapped,
            scheduleTimeArray: scheduleTimeArray
        };
    }
    return {
        scheduleDayArrayMapped: [],
        scheduleTimeArray: []
    };
};
/* harmony default export */ var utils_mapJobSchedule = (mapJobSchedule);

// EXTERNAL MODULE: ./src/utils/generateEnrollmentUrl.ts + 1 modules
var generateEnrollmentUrl = __webpack_require__(85715);
// EXTERNAL MODULE: ./src/components/SeoGlobalNavbar.tsx
var SeoGlobalNavbar = __webpack_require__(8410);
// EXTERNAL MODULE: ./src/components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(22284);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
// EXTERNAL MODULE: ./src/components/GAMAds.tsx
var GAMAds = __webpack_require__(5823);
;// CONCATENATED MODULE: ./src/components/pages/segmentationDetails/job/JobDetailPage.tsx




























var ref = config_default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var JobDetailPage = function(param) {
    var data = param.data, serviceShortName = param.serviceShortName, testName = param.testName, deviceChar = param.deviceChar;
    var ref = (0,useLDClientFlags/* useLDClientFlags */.y)(), GAMFlag = ref.SEO_3487_GAM_ADS_SEO_MFE;
    var showGAMAds = (GAMFlag === null || GAMFlag === void 0 ? void 0 : GAMFlag.variationIndex) === 1;
    var gamRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isGamVisible = ref1[0], setIsGamVisible = ref1[1];
    (0,react.useEffect)(function() {
        var trackPageViewAndTestExposureEvents = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var amplitudeDataForTestExposure;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!testName) return [
                                3,
                                2
                            ];
                            amplitudeDataForTestExposure = {
                                test_name: testName,
                                test_variant: "1",
                                service_short_name: serviceShortName
                            };
                            return [
                                4,
                                (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, amplitudeDataForTestExposure)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                4,
                                (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.jobViewed */.Sj.jobViewed)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function trackPageViewAndTestExposureEvents() {
                return _ref.apply(this, arguments);
            };
        }();
        trackPageViewAndTestExposureEvents();
    }, [
        serviceShortName,
        testName
    ]);
    (0,react.useEffect)(function() {
        if (isGamVisible && GAMFlag && GAMFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3487_GAM_ADS_SEO_MFE.id */.WV.SEO_3487_GAM_ADS_SEO_MFE.id,
                test_variant: GAMFlag.variationIndex,
                service_short_name: serviceShortName
            });
        }
    }, [
        GAMFlag,
        isGamVisible,
        serviceShortName
    ]);
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var showJobAdditionalDetails = serviceShortName === constants/* SERVICE_ID_FOR_JOB_DETAILS.childcare */.Dg.childcare || serviceShortName === constants/* SERVICE_ID_FOR_JOB_DETAILS.petcare */.Dg.petcare || serviceShortName === constants/* SERVICE_ID_FOR_JOB_DETAILS.housekeeping */.Dg.housekeeping || serviceShortName === constants/* SERVICE_ID_FOR_JOB_DETAILS.tutoring */.Dg.tutoring;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg");
    var getSEOSegmentationJobDetails = data.getSEOSegmentationJobDetails;
    var seoSegmentationJob = (getSEOSegmentationJobDetails || {}).seoSegmentationJob;
    var breadcrumbs = (data === null || data === void 0 ? void 0 : data.getSEOSegmentationBreadcrumbs.breadcrumbs) || [];
    var pageMetadata = (getSEOSegmentationJobDetails || {}).pageMetadata;
    var schemaLdJson = getSEOSegmentationJobDetails === null || getSEOSegmentationJobDetails === void 0 ? void 0 : getSEOSegmentationJobDetails.googleRichCardStructuredJson;
    var stringifyDeviceChar = JSON.stringify(deviceChar);
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: constants/* ScreenName.JOB */.CG.JOB,
            screen_template: constants/* ScreenTemplate.JOB */.Yj.JOB,
            seo_page_id: constants/* SeoPageId.JOB */.IH.JOB,
            slots: constants/* TealiumSlot.VISITOR */.vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        stringifyDeviceChar,
        deviceChar
    ]);
    var caregiverPreferences = (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.jobPreferences) ? utils_mapJobPreferences(seoSegmentationJob.jobPreferences) : [];
    var jobSchedule = (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.schedule) ? utils_mapJobSchedule(seoSegmentationJob.schedule) : null;
    var enrollmentURL = (0,generateEnrollmentUrl/* default */.Z)({
        serviceIdForMember: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.serviceIdForMember) || "",
        serviceId: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.serviceId) || "",
        isMobile: isMobile
    });
    var jobSchemaLdJson = function() {
        return schemaLdJson;
    };
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsGamVisible(true);
                observer.disconnect();
            }
        }, {
            threshold: 0.5
        });
        var currentGamRef = gamRef.current;
        if (currentGamRef) {
            observer.observe(currentGamRef);
        }
        return function() {
            if (currentGamRef) {
                observer.unobserve(currentGamRef);
            }
        };
    }, [
        gamRef,
        isMobile
    ]);
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.metaDescriptions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.metaKeywords
                    }),
                    (pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.indexable) && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "verify-v1",
                        content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: logoPath
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.canonicalURL
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: pageMetadata === null || pageMetadata === void 0 ? void 0 : pageMetadata.metaDescriptions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Care.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "image/jpeg",
                        property: "og:image:type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "1080",
                        property: "og:image:width"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "1080",
                        property: "og:image:height"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "/img/care-no-tag.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "fb:page_id",
                        content: "6030284861"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "http://schema.org",
                                "@type": "Organization",
                                logo: logoPath,
                                name: "Care.com",
                                sameAs: [
                                    "https://www.facebook.com/caredotcom/",
                                    "https://twitter.com/CareDotCom",
                                    "https://www.instagram.com/careorg/",
                                    "https://www.linkedin.com/company/care-com", 
                                ],
                                url: "https://www.care.com"
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* default */.Z, {
                enrollmentURL: enrollmentURL
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 4,
                    mt: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                        breadcrumbs: breadcrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_JobIntro, {
                title: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.job.title) || "",
                hiResImageURL: (ref2 = seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.seekerAvatar) !== null && ref2 !== void 0 ? ref2 : undefined,
                payRange: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.job.hourlyRateRange) || null,
                city: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.city) || "",
                state: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.state) || "",
                startDate: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.job.startDate) || "",
                joinNowURL: enrollmentURL,
                type: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.type) || null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    sx: {
                        pl: {
                            md: 3
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_JobDescription, {
                profileDesc: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.description) || ""
            }),
            showGAMAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                ref: gamRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                    slotName: constants/* HTL_SLOTS.SEO_JOB_PROFILE_INLINE_1 */.YQ.SEO_JOB_PROFILE_INLINE_1
                })
            }),
            showJobAdditionalDetails && (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.jobPreferences) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "md",
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                pl: {
                                    md: 3
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_JobAdditionalDetails, {
                        jobPreferences: seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.jobPreferences,
                        serviceName: serviceShortName
                    })
                ]
            }),
            caregiverPreferences.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "md",
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                pl: {
                                    md: 3
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_JobPreferences, {
                        jobPreferences: caregiverPreferences,
                        serviceName: serviceShortName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                disableGutters: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    sx: {
                        pl: {
                            md: 3
                        }
                    }
                })
            }),
            jobSchedule && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_JobSchedule, (0,_object_spread/* default */.Z)({}, jobSchedule)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        maxWidth: "md",
                        disableGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                pl: {
                                    md: 3
                                }
                            }
                        })
                    })
                ]
            }),
            showGAMAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GAMAds/* GAMAds */.U, {
                    slotName: constants/* HTL_SLOTS.SEO_JOB_PROFILE_INLINE_2 */.YQ.SEO_JOB_PROFILE_INLINE_2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Jobs_NearbyJobs, {
                jobs: (getSEOSegmentationJobDetails === null || getSEOSegmentationJobDetails === void 0 ? void 0 : getSEOSegmentationJobDetails.nearbyJobs) || []
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                mt: {
                    xs: 8,
                    md: 10
                },
                mb: {
                    md: 8
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoConversionBox/* default */.Z, {
                    header: "When do you want a job?",
                    enrollmentURL: enrollmentURL,
                    serviceId: (seoSegmentationJob === null || seoSegmentationJob === void 0 ? void 0 : seoSegmentationJob.serviceId) || ""
                })
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 4,
                    mt: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                        breadcrumbs: breadcrumbs
                    })
                })
            }),
            schemaLdJson && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: (ref3 = jobSchemaLdJson()) !== null && ref3 !== void 0 ? ref3 : ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var job_JobDetailPage = (JobDetailPage);
var getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                jobDetailPageProps(context)
            ];
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/segmentationDetails/job/index.ts


;// CONCATENATED MODULE: ./src/pages/job/[vertical]/[state]/[city]/[jobId].tsx
var __N_SSP = true;



/***/ }),

/***/ 28057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getGAMVerticalShortName; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79967);


var getGAMVerticalShortName = function(serviceId) {
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CAREGIGSX */ .Xs.CAREGIGSX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.CARE_GIGS */ .UW.CARE_GIGS) {
        return "cg";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.PETCAREXX */ .Xs.PETCAREXX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.PET_CARE */ .UW.PET_CARE) {
        return "pc";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.SENIRCARE */ .Xs.SENIRCARE || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.SENIOR_CARE */ .UW.SENIOR_CARE) {
        return "sc";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.TUTORINGX */ .Xs.TUTORINGX || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.TUTORING */ .UW.TUTORING) {
        return "tu";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.HOUSEKEEP */ .Xs.HOUSEKEEP || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.HOUSEKEEPING */ .UW.HOUSEKEEPING) {
        return "hk";
    }
    if (serviceId === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CHILDCARE */ .Xs.CHILDCARE || serviceId === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_1__/* .ServiceType.CHILD_CARE */ .UW.CHILD_CARE) {
        return "cc";
    }
    return "none";
};



/***/ }),

/***/ 26008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ formatStartDate; }
/* harmony export */ });
var formatStartDate = function(dateInput) {
    var useLongMonth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    // Ensure the date is consistently formatted in a format like "YYYY-MM-DD" to "YYYY/MM/DD"
    var formattedDate = new Date(dateInput.replace(/-/g, "/")).toLocaleString("en-us", {
        month: useLongMonth ? "long" : "short",
        day: "numeric"
    }).split(" ");
    return {
        month: formattedDate[0],
        day: formattedDate[1]
    };
};


/***/ }),

/***/ 85715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_generateEnrollmentUrl; }
});

;// CONCATENATED MODULE: ./src/utils/getServerSidePropsUtil.ts
// Write tests for these and use them in getServerSideProps
var getSegmentUrl = function(query) {
    var ref;
    var segmentURL = (ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString();
    var ref1;
    var pageStringArr = (ref1 = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.split("-page")) !== null && ref1 !== void 0 ? ref1 : ""; // remove anything after -page
    return "/".concat(pageStringArr[0]);
};
var getVerticalUrl = function(query) {
    var ref;
    var verticalURL = (ref = query.vertical) === null || ref === void 0 ? void 0 : ref.toString();
    return "".concat(verticalURL);
};
var getPageNumber = function(query) {
    var ref;
    var segmentURL = ((ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString()) || "";
    var page = 1;
    var urlPageNumber = segmentURL === null || segmentURL === void 0 ? void 0 : segmentURL.replace(/^\D+/g, ""); // find number
    if (urlPageNumber.length > 0) {
        page = Number(urlPageNumber);
    }
    return page;
};

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/utils/generateEnrollmentUrl.ts


var generateEnrollmentUrl = function(param) {
    var router = param.router, serviceIdForMember = param.serviceIdForMember, tmp = param.serviceId, argServiceId = tmp === void 0 ? "" : tmp, _serviceShortName = param.serviceShortName, serviceShortName = _serviceShortName === void 0 ? "" : _serviceShortName, serviceProfileId = param.serviceProfileId, _directoryFirstExperience = param.directoryFirstExperience, directoryFirstExperience = _directoryFirstExperience === void 0 ? false : _directoryFirstExperience;
    var serviceId = argServiceId !== "" ? argServiceId : constants/* SEO_SERVICE_SHORT_NAMES */.Mk[serviceShortName];
    var serviceDetails = constants/* SEO_SERVICE_DETAILS */.Jm[serviceId];
    var fromSeoPage = "fromSeoPage=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.fromSeoPage */.BC.fromSeoPage);
    var serviceIdParam = "serviceId=".concat(serviceId);
    var memberServiceId = serviceIdForMember !== null && serviceIdForMember !== void 0 ? serviceIdForMember : constants/* SEO_SERVICE_DETAILS */.Jm[serviceId].serviceIdForMemberVal;
    var segmentUrl = (router === null || router === void 0 ? void 0 : router.query.segment) ? getSegmentUrl(router.query) : "";
    if (memberServiceId === memberServiceId.toUpperCase()) {
        memberServiceId = memberServiceId.toLowerCase();
    }
    var adultCareSegments = [
        "/adult-care",
        "/special-needs-adult-care",
        "/post-surgery-care"
    ];
    if (serviceIdForMember === "childCareLocation") {
        memberServiceId = "dayCare";
    } else if (adultCareSegments.includes(segmentUrl)) {
        memberServiceId = "adultCare";
    }
    var serviceIdForMemberParam = "serviceIdForMember=".concat(memberServiceId);
    var source = "source=".concat(constants/* COMMON_SEO_ENROLLMENT_PARAMS.source */.BC.source);
    var pageSource = "pageSource=".concat(serviceDetails.pageSource);
    var visitedServiceProfileId = serviceProfileId ? "&visitedServiceProfileId=".concat(serviceProfileId) : "";
    var enrollmentQueryParams = "".concat(fromSeoPage, "&").concat(serviceIdParam, "&").concat(serviceIdForMemberParam, "&").concat(source, "&").concat(pageSource).concat(visitedServiceProfileId);
    var enrollmentType = memberServiceId.slice(memberServiceId.length - 3) === "Job" ? "provider" : "seeker";
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS */.u2.CARE_GIGS) {
        return "/app/vhp/care-kind?".concat(enrollmentQueryParams);
    }
    if (directoryFirstExperience && serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION) {
        return "/app/business-search?".concat(enrollmentQueryParams);
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS */.u2.SPECIAL_NEEDS) {
        return "/app/enrollment/".concat(enrollmentType, "/cc?").concat(enrollmentQueryParams);
    }
    // careGigsJob and specialNeedsJob to vertical-triage enrollment flow since they dont have a dedicated flow.
    // The multi-vertical flow will be used on "/jobs, /full-time-jobs, and /part-time-jobs" segmentation pages (these are under childCareJobs):
    if (serviceIdForMember === constants/* ServiceIdForMember.CARE_GIGS_JOB */.u2.CARE_GIGS_JOB || serviceIdForMember === constants/* ServiceIdForMember.SPECIAL_NEEDS_JOB */.u2.SPECIAL_NEEDS_JOB || segmentUrl === "/jobs" || segmentUrl === "/full-time-jobs" || segmentUrl === "/part-time-jobs") {
        return "/app/vhp/vertical-triage?memberType=sitter&".concat(enrollmentQueryParams);
    }
    // Job search enrollment URL
    if (enrollmentType === "provider") {
        return "/app/enrollment/provider/mv/".concat(serviceId, "?").concat(enrollmentQueryParams);
    }
    if (serviceId === constants/* ServiceId.SENIRCARE */.Xs.SENIRCARE && serviceIdForMember === constants/* ServiceIdForMember.HOUSING_LOCATION */.u2.HOUSING_LOCATION) {
        // This is specific to Senior Assisted Living Communities( In facility care or OOH)
        return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "/").concat(constants/* SC_SEEKER_IN_FACILITY_ROUTES.WHO_NEEDS_CARE */.oF.WHO_NEEDS_CARE, "?").concat(enrollmentQueryParams);
    }
    return "/app/enrollment/".concat(enrollmentType, "/").concat(serviceDetails.shortName, "?").concat(enrollmentQueryParams);
};
/* harmony default export */ var utils_generateEnrollmentUrl = (generateEnrollmentUrl);


/***/ }),

/***/ 93867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28906);

var getDeviceCharacteristics = function(userAgent, deviceCharHeader) {
    var deviceChar = (0,_reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deviceCharHeader, ";");
    if (Object.keys(deviceChar).length === 0) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            deviceChar = {
                is_mobile: "true"
            };
        } else {
            deviceChar = {
                is_mobile: "false"
            };
        }
    }
    return deviceChar;
};
/* harmony default export */ __webpack_exports__["Z"] = (getDeviceCharacteristics);


/***/ }),

/***/ 32150:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var payRangeHelper = function(hourlyRateTo, hourlyRateFrom) {
    var showUnit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ((hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0 && Number(hourlyRateTo) < 10) {
        return "< $10/hr";
    }
    if ((hourlyRateFrom === null || hourlyRateFrom === void 0 ? void 0 : hourlyRateFrom.length) > 0 && (hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0) {
        var str = "";
        if (Number(hourlyRateFrom) === Number(hourlyRateTo)) {
            str = "$".concat(hourlyRateFrom);
        } else if (Number(hourlyRateFrom) === 0) {
            str = ">$".concat(hourlyRateTo);
        } else {
            str = "$".concat(hourlyRateFrom, "-").concat(hourlyRateTo);
        }
        return showUnit ? "".concat(str, "/hr") : str;
    }
    if ((hourlyRateFrom === null || hourlyRateFrom === void 0 ? void 0 : hourlyRateFrom.length) > 0) {
        return "> $".concat(hourlyRateFrom);
    }
    return (hourlyRateTo === null || hourlyRateTo === void 0 ? void 0 : hourlyRateTo.length) > 0 ? "< $".concat(hourlyRateTo) : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (payRangeHelper);


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/**
 * Transmutes a key/value pairs object into the format expected by GraphQLEnumType
 * @param  {string} header header string of keys and values
 * @param  {string} delimeter symbol used to separate each key value pair from the next pair
 * @param  {string} valueDelimeter symbol used to separate the key from its value within each pair
 * @return {Object}     Entries object (key/value pairs)
 */ 
var reqHeaderToEntriesObj = function(header) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ";", valueDelimeter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    if (header === "") return {};
    return header.split(delimiter).reduce(function(accum, curVal) {
        var obj = accum;
        var keyValuePair = curVal.split(valueDelimeter);
        var _keyValuePair = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(keyValuePair, 2), keyValuePairKey = _keyValuePair[0], keyValuePairValue = _keyValuePair[1];
        obj[keyValuePairKey] = keyValuePairValue;
        return obj;
    }, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (reqHeaderToEntriesObj);


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,6506,6886,9417,5995,1136,1767,1036,3370,9774,2888,179], function() { return __webpack_exec__(31293); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);